import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=21b92bc3&scoped=true&"
import script from "./CSelect.vue?vue&type=script&lang=js&"
export * from "./CSelect.vue?vue&type=script&lang=js&"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=21b92bc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b92bc3",
  null
  
)

export default component.exports